import React, { useState } from "react";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import useTranslate from "../../../../hooks/useTranslate";
import { QuestionResultModel } from "../../../../types/SurveyResult";
import MaskedInput from 'react-text-mask';

export default function (props: SurveyQuestionProps) {
    let currentResult = props.result as QuestionResultModel;
    const currentAnswer = currentResult.Answers[0] || "";
    let defaultPlaceholder = useTranslate(["default-phonenumber-placeholder"])["default-phonenumber-placeholder"];
    let placeholder = props.placeholder || defaultPlaceholder;

    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    function answerChanged(answer: string) {
        const onlyDigits = answer.replace(/\D/g, '');
        const phoneNumber = onlyDigits.slice(-10); // removes autofilled country codes

        const isValid = (props.optional && phoneNumber.length === 0) || phoneNumber.length === 10;

        props.onResultChange({
            ...props.result,
            Answers: [phoneNumber],
            invalid: !isValid
        } as QuestionResultModel);
    }

    return <SurveyFormItem
        topBorder
        bottomBorder
        label={props.label}
        labelFor={props.inputIdForLabel}
        labelPosition={props.labelPosition}
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <MaskedInput
            id={props.inputIdForLabel}
            inputMode='tel'
            mask={phoneMask}
            value={currentAnswer}
            placeholder={placeholder}
            //autofill events may only trigger input rather than change
            onInput={(e) => answerChanged((e.target as HTMLInputElement).value)}
            //after auto-filling multiple fields the input is blurred, but blur event is not trigered, so we need to use animation end to trigger it
            onAnimationEnd={(event) => {
                if (event.animationName === 'autoFillAnimation') {
                    const syntheticEvent = {
                        target: event.target
                    } as React.ChangeEvent<HTMLInputElement>;
                    answerChanged((event.target as any).value);
                }
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => answerChanged(e.target.value)}
            guide={false}
            autoComplete={props.autoComplete}
            className={`survey-input ${props.variant === 'v2' ? 'survey-input-v2' : ''} ${props.variant}`}
        />
    </SurveyFormItem>
}